module.exports = __webpack_public_path__ + "img/Bahamas.4939a98b.svg";